// extracted by mini-css-extract-plugin
export var visuallyHidden = "SearchFormQueryField-module--visuallyHidden--z+H6E";
export var wrapper = "SearchFormQueryField-module--wrapper--04MOK";
export var input = "SearchFormQueryField-module--input--LpPne";
export var submit = "SearchFormQueryField-module--submit--DQQcE";